<template>
  <section
    :data-automated-browser-modal="show ? '1' : '0'"
  >
    <div class="rounded-md bg-red-50 p-4 fixed z-50 left-0 right-0 top-0" v-if="show">
      <div class="flex mx-auto max-w-4xl">
        <div class="shrink-0">
          <ExclamationTriangleIcon class="size-5 text-red-400" aria-hidden="true" />
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-red-800"><strong class="font-semibold">Warning:</strong> Automated browser detected</h3>
          <div class="mt-2 text-sm text-red-700">
            <p>Using the MailSlurp dashboard in automation test tools is not recommended because the interface can change. Instead use <a class="abd-link" href="https://docs.mailslurp.com/testing/" target="_blank">SDK clients programmatically</a> or use the visual <a href="https://docs.mailslurp.com/test-interface" target="_blank" class="abd-link">test interface</a>. See <a target="_blank" class="abd-link" href="https://docs.mailslurp.com/testing/">https://docs.mailslurp.com/testing/</a>.</p>
          </div>
          <div class="mt-4">
            <div class="-mx-2 -my-1.5 flex">
              <a data-testid='automated-browser-modal-docs' href="https://docs.mailslurp.com/testing" class="rounded-md bg-red-50 px-2 py-1.5 text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50">View documentation</a>
              <button data-testid='automated-browser-modal-dismiss' type="button" class="ml-3 rounded-md bg-red-50 px-2 py-1.5 text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50" @click="accept">Dismiss</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style>
.abd-link {
  text-decoration: underline;
}
</style>
<script lang="ts" setup>
import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid'
import { isAutomatedBrowser } from '@mailslurp/detect-automated-browser'
import { useNuxtApp } from '#imports';
const runtimeConfig = useRuntimeConfig();
const isProd = runtimeConfig?.public?.environment === 'production';
const key = 'automated-browser-acknowledged';
const overrideKey = 'show-automated-browser-modal';
const show = ref(false);
const { $captureEvent: captureEvent } = useNuxtApp();
const hasShowOverride = () => {
  try {
    return sessionStorage.getItem(overrideKey)
  } catch (e) {
    return false
  }
};
const isAccepted = () => {
  return localStorage.getItem(key)
};
const accept = () => {
  captureEvent('automated_browser_modal_dismissed');
  show.value = false;
  try {
    localStorage.setItem(key, 'true');
  } catch (e) {
    console.warn('Could not acknowledge automated browser', e)
  }
};
onMounted(() => {
  try {
    if ((isProd || hasShowOverride()) && !isAccepted() && isAutomatedBrowser()) {
      captureEvent('automated_browser_modal_displayed');
      show.value = true;
    }
  } catch (e) {
    console.warn('Could not run automated browser detection', e)
  }
})
</script>